import React from 'react';
import './VideoPlay.css';

const VideoPlay = ({ videoUrl,data, onClose }) => {
  const getEmbedUrl = (url) => {
    const videoIdMatch = url.match(/(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
    const videoId = videoIdMatch ? videoIdMatch[1] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
  };

  return (
    <div className="video-modal-overlay" onClick={onClose}>
    <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
  <button className="video-close-button" onClick={onClose}>
    &times;
  </button>
  <div className="video-responsive">
    <iframe
      src={getEmbedUrl(videoUrl)}
      title="YouTube video player"
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
    ></iframe>
  </div>
  <div className="title-area text-center">
          <h2 class="sec-title">Description</h2>
        </div>
  <div className="video-description">{data}</div>
</div>

    </div>
  );
};

export default VideoPlay;
